import { TableCell, TableRow } from "@mui/material";
import { RoundType } from "../../interfaces/ICompetitions";

interface ResultsTableHeadProps {
  roundType: RoundType;
}

export default function ResultsTableHead({ roundType }: ResultsTableHeadProps) {
  return (
    <TableRow>
      {roundType === RoundType.FINAL && (
        <TableCell
          sx={{ fontWeight: 600, fontSize: "0.875rem", width: "40px" }}
          align="center"
        >
          Miejsce
        </TableCell>
      )}
      <TableCell
        sx={{
          fontWeight: 600,
          fontSize: "0.875rem",
          width: "60px",
          paddingLeft: { xs: 1, sm: 1.5 },
          paddingRight: { xs: 1, sm: 1.5 },
        }}
        align="center"
      >
        Numer startowy
      </TableCell>
      {roundType === RoundType.ELIMINATIONS && (
        <TableCell
          sx={{
            fontWeight: 600,
            fontSize: "0.875rem",
            width: "60px",
            paddingLeft: { xs: 0.5, sm: 1 },
            paddingRight: { xs: 0.5, sm: 1 },
          }}
          align="center"
        >
          Awans
        </TableCell>
      )}
      <TableCell
        sx={{
          fontWeight: 600,
          fontSize: "0.875rem",
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        Nazwa
      </TableCell>
    </TableRow>
  );
}

